export const BYPASS_SAASY_ENV_VAR = 'NEXT_PUBLIC_BYPASS_SAASY';

export function isSaaSyBypassed(
  value = process.env.NEXT_PUBLIC_BYPASS_SAASY
): boolean {
  return value !== 'false';
}

export function isSaaSyEnabled(
  value = process.env.NEXT_PUBLIC_BYPASS_SAASY
): boolean {
  return !isSaaSyBypassed(value);
}
